<template>
  <DialogTutorialBase :delay-button="800" v-bind="props">
    <template #title> Installe l’app Nomad 📲 </template>
    <DomFade :delay="10">
      Ton coach et tes contenus de révision dispos
      <strong>où tu veux quand tu veux</strong> pour réviser même en last minute
      ?
    </DomFade>
    <DomFade :delay="100">
      Facile, <strong>télécharge l’app direct</strong>, c’est
      <strong>gratuit</strong> 💯
    </DomFade>
    <DomFade tag="ul" :delay="220" class="stores">
      <li>
        <nuxt-link
          class="direct"
          to="https://itunes.apple.com/app/id1441761075?mt=8"
        >
          <img
            src="~/assets/images/apple-app-store.png"
            alt="Apple App store"
          />
        </nuxt-link>
      </li>
      <li>
        <nuxt-link
          class="direct"
          to="https://play.google.com/store/apps/details?id=com.nomadeducation.nomadeducation&pcampaignid=web_share"
        >
          <img
            src="~/assets/images/google-play-badge.png"
            alt="Google Play store"
          />
        </nuxt-link>
      </li>
    </DomFade>
  </DialogTutorialBase>
</template>
<script lang="ts" setup>
interface Props {
  onNext: Function;
}
const props = defineProps({
  onNext: { type: Function }
});
</script>
<style lang="scss" scoped>
.stores {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  li {
    width: 100px;
  }
}
</style>
